const ADDRESS_NOT_LISTED = 'My address is not listed'

export const regexPostcode =
  /^(([Gg][Ii][Rr] ?0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?[0-9][A-Za-z]{2}))$/

export const regexPartPostcode = /^$|^[A-Za-z][A-Za-z0-9\s]*$/

export const getOutcode = (postcode) => {
  if (!isValidPostcode(postcode.trim())) return false
  const outcode = postcode.trim().slice(0, -3).toUpperCase().trim()
  return outcode
}

export const getIncode = (postcode) => {
  if (!isValidPostcode(postcode.trim())) return false
  const incode = postcode.trim().slice(-3).toUpperCase().trim()
  return incode
}

export const formatPostcode = (postcode) => {
  if (isValidPostcode(postcode.trim())) {
    const outcode = getOutcode(postcode)
    const incode = getIncode(postcode)
    return `${outcode} ${incode}`
  } else {
    return postcode.trim()
  }
}

export const isValidPostcode = (postcode) => regexPostcode.test(postcode)

export const isValidPartPostcode = (postcode) => regexPartPostcode.test(postcode)

export const noAddressListed = (postcode) => ({
  summaryLine: ADDRESS_NOT_LISTED,
  uprn: '',
  udprn: '',
  postcode: formatPostcode(postcode)
})
